import UI from '../stores/UI'
import Picture from './Picture'

class BackgroundPicture extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      src: '',
      ready: false
    }
  }

  componentDidMount() {
    UI.updateLoading(true, 'loading bg picture')
    this.img.addEventListener('load', this.loadImage)
  }

  componentWillUnmount() {
    this.img.removeEventListener('load', this.loadImage, false)
  }

  loadImage = () => {
    this.update()
  }

  update() {
    let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
    if (this.src !== src) {
      this.setState({
        src: src,
        ready: true
      })
      UI.updateLoading(false, 'loading bg picture')
    }
  }

  render() {

    const src = this.img ? this.img.currentSrc : ''

    const css = {
      backgroundImage: `url(${this.state.src})`,
      opacity: this.state.ready ? 1 : 0,
      transition: `opacity 0.5s`
    }

    return (
      <div className={`${this.props.className} ${this.state.ready}`} style={css} >
        <Picture src={this.props.src} className="hide-img" width={this.props.width} height={this.props.height} innerRef={el => this.img = el} isBackground />
      </div>
    )
  }
}

export default BackgroundPicture



// WEBPACK FOOTER //
// ./app/javascript/packs/components/BackgroundPicture.js